
import { Injectable } from '@angular/core';
import { AuthHttp, AuthConfig, JwtHelper } from 'angular2-jwt';
import { Router } from '@angular/router';
const jwtHelper: JwtHelper = new JwtHelper();

@Injectable()
export class TokenService {

  constructor(private router: Router) { }

  isLogin() {
    const token = this.getToken();
    return !!token && !this.isTokenExpired(token);
  }

  setToken(token) {

    localStorage.setItem('currentUser', token);
    localStorage.setItem('profile', JSON.stringify(jwtHelper.decodeToken(token)));
  }

  setPersmission(permission) {
    localStorage.setItem('userPermission', JSON.stringify(permission));
  }

  setDefaultPath(path) {
    localStorage.setItem('defaultPath', JSON.stringify(path));
  }

  setCompanyAccess(access) {
    localStorage.setItem('companyAccess', JSON.stringify(access));
  }

  getPermissioin() {
    const userPermission = localStorage.getItem('userPermission');
    return userPermission ? JSON.parse(userPermission) : [];
  }

  getDefaultPath() {
    const defaultPath = localStorage.getItem('defaultPath');
    return defaultPath ? JSON.parse(defaultPath) : '';
  }

  getCompanyAccess() {
    const companyAccess = localStorage.getItem('companyAccess');
    return companyAccess ? JSON.parse(companyAccess) : '';
  }

  getProfile() {
    const profile = localStorage.getItem('profile');
    return profile ? JSON.parse(profile) : { given_name: '' };
  }

  setRefToken(token) {

    localStorage.setItem('refToken', token);
  }
  setRoleToken(role) {
    localStorage.setItem('role', role);
  }
  getRefToken() {
    return localStorage.getItem('refToken');
  }

  getToken() {
    return localStorage.getItem('currentUser');
  }

  getTokenExpirationDate(token) {
    const decoded = jwtHelper.decodeToken(token);

    if (!decoded.exp) {
      return null;
    }

    const date = new Date(0); // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token) {
    const date = this.getTokenExpirationDate(token);
    if (date === null) {
      return false;
    }
    return !(date.valueOf() > new Date().valueOf());
  }


  isRefreshNeeded() {
    return this.isNeedToRefreshToken(this.getToken());
  }

  isNeedToRefreshToken(token) {
    const d = this.getTokenExpirationDate(token);

    if (!d) {
      return false;
    }

    const ticks = d.valueOf() - new Date().valueOf();
    const mm = Math.round((ticks / (60 * 1000)) % 60);

    return (mm <= 10);
  }


  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('refToken');
    localStorage.removeItem('profile');
    localStorage.removeItem('userPermission');
    localStorage.removeItem('access_token');
    localStorage.removeItem('role');

    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/service/token.service.ts